export const LECTURE_REQUEST = 'LECTURE_REQUEST';
export const LECTURE_SUCCESS = 'LECTURE_SUCCESS';
export const LECTURE_FAILURE = 'LECTURE_FAILURE';

export const SET_LECTURE_LOADING = 'SET_LECTURE_LOADING';

export const SET_LECTURE_ERROR = 'SET_LECTURE_ERROR';
export const CLEAR_LECTURE_ERROR = 'CLEAR_LECTURE_ERROR';

export const SECTIONS_REQUEST = 'SECTIONS_REQUEST';
export const SECTIONS_SUCCESS = 'SECTIONS_SUCCESS';
export const SECTIONS_FAILURE = 'SECTIONS_FAILURE';

export const CREATE_LECTURE_REQUEST = 'CREATE_LECTURE_REQUEST';
export const CREATE_LECTURE_SUCCESS = 'CREATE_LECTURE_SUCCESS';
export const CREATE_LECTURE_FAILURE = 'CREATE_LECTURE_FAILURE';

export const DELETE_LECTURE_REQUEST = 'DELETE_LECTURE_REQUEST';
export const DELETE_LECTURE_SUCCESS = 'DELETE_LECTURE_SUCCESS';
export const DELETE_LECTURE_FAILURE = 'DELETE_LECTURE_FAILURE';

export const EDIT_LECTURE_REQUEST = 'EDIT_LECTURE_REQUEST';
export const EDIT_LECTURE_SUCCESS = 'EDIT_LECTURE_SUCCESS';
export const EDIT_LECTURE_FAILURE = 'EDIT_LECTURE_FAILURE';

export const RESET_LECTURE_EDITED = 'RESET_LECTURE_EDITED';

export const ADD_LECTURE_TO_SECTION = 'ADD_LECTURE_TO_SECTION';

export const CREATE_NEW_SECTION = 'CREATE_NEW_SECTION';

export const SYNC_EXISTING_LECTURES_REQUEST = 'SYNC_EXISTING_LECTURES_REQUEST';
export const SYNC_EXISTING_LECTURES_FAILURE = 'SYNC_EXISTING_LECTURES_FAILURE';
export const SYNC_EXISTING_LECTURES_SUCCESS = 'SYNC_EXISTING_LECTURES_SUCCESS';
